export var videosHandler = {
    init: function (videoSelector, playBtnSelector) {
        var _this = this;
        document.querySelectorAll(videoSelector).forEach(function (videoContainer) {
            var _a;
            (_a = videoContainer
                .querySelector(playBtnSelector)) === null || _a === void 0 ? void 0 : _a.addEventListener('click', _this.playBtnClickHandler.bind(_this));
        });
    },
    playBtnClickHandler: function (event) {
        var currentTarget = event.currentTarget;
        var dataSource = currentTarget.dataset.source;
        var isMuted = currentTarget.dataset.muted === 'true';
        currentTarget.parentElement.innerHTML =
            '<iframe width="100%" class="video" height="100%" src="https://www.youtube.com/embed/' +
                dataSource +
                "?autoplay=1".concat(isMuted ? '&mute=1' : '', "&rel=0&amp;controls=1&amp;showinfo=0&enablejsapi=1\" frameborder=\"0\" allowfullscreen allow=\"autoplay\"></iframe>");
    },
};
